import { replaceAll } from './strings.js';
export const defaultLocale = 'en-US';
/**
 * Intacct supports various locales and includes some that we may not support.
 * The course of action we are taking now is to support fallbacks where available.
 * Fallbacks can include simply mapping `en` -> `en-US`, but also lesser used locales like `en-ZA` -> `en-US`.
 * Similarly, `fr` -> `fr-FR`.
 *
 * ```php
 * 'LOCALE_IDENTIFIER' => [
 *     'en'    => 'en_US.UTF-8',
 *     'en-AU' => 'en_AU.UTF-8',
 *     'en-US' => 'en_US.UTF-8',
 *     'en-GB' => 'en_GB.UTF-8',
 *     'en-ZA' => 'en_ZA.UTF-8',
 *     'fr'    => 'fr_FR.UTF-8',
 *     'fr-FR' => 'fr_FR.UTF-8',
 *     'fr-CA' => 'fr_CA.UTF-8',
 *     'de'    => 'de_DE.UTF-8',
 *     'de-DE' => 'de_DE.UTF-8',
 *     'es'    => 'es_ES.UTF-8',
 *     'es-ES' => 'es_ES.UTF-8'
 * ],
 * ```
 *
 * @see https://github.com/intacct/ia-app/blob/4abf5391b95ad048c69cf00d26f3b45220338f8e/app/source/common/backend_locale.inc#L60
 */
const intacctFallbackLocales = {
    // The cases here are the non-English locales that don't match APP_LOCALES.
    // We don't need to specify all English fallbacks because we always fallback to English on unknown locales anyways.
    fr: 'fr-FR',
    de: 'de-DE',
    es: 'es-ES',
};
export const APP_LOCALES = new Set([
    'de-DE',
    'en-US',
    'es-ES',
    'fr-CA',
    'fr-FR',
    'en-US-pseudo',
]);
function isAppLocale(locale) {
    return APP_LOCALES.has(locale);
}
export function toHyphenCase(locale) {
    return replaceAll(locale, '_', '-');
}
export function toSnakeCaseLocale(locale) {
    return replaceAll(locale, '-', '_');
}
/**
 * Assumes that the input is a locale string in the format of `en-US`, `fr-FR`, etc.
 * Does not map underscores to hyphens, so `fr_CA` will not be converted to `fr-CA` but rather map to `en-US` (default).
 */
export function toAppLocale(locale) {
    if (!locale)
        return defaultLocale;
    if (isAppLocale(locale)) {
        return locale;
    }
    return intacctFallbackLocales[locale] ?? defaultLocale;
}
//# sourceMappingURL=locale.js.map